import { BreadcrumbOption } from '@conexasaude/hero-web'

export const BREADCRUMBS_OPTIONS: BreadcrumbOption[] = [
  { route: '/', title: 'Início' },
  { route: '/teste-de-chamada', title: 'Teste de chamada' },
]
